var map = {
	"./menu1.png": "hMLq",
	"./menu2.png": "Mqir"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0eXl";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/menu.*\.png$
// module id = 0eXl
// module chunks = 45